import React, { useState, useEffect } from 'react';
import { X, Instagram, Facebook, Linkedin, Twitter, Download } from 'lucide-react';

// TikTok Icon
const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

// Snapchat Icon  
const SnapchatIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838 0 .179-.089.344-.283.509-.206.179-.48.329-.797.484l-.145.07c-.451.195-1.047.466-1.26.918-.18.36-.12.73-.076 1.139.045.389.105.898-.165 1.465-.629 1.447-2.181 2.191-4.761 2.191l-.33-.009c-.39 0-.824.09-1.241.18-.459.104-.914.18-1.26.18-.254 0-.389-.074-.404-.104-.24-.449-.24-.9-.24-1.34 0-.479.015-.959.045-1.421l.015-.195c.015-.195.029-.375.029-.539 0-.254-.06-.479-.239-.674-.209-.224-.584-.389-1.091-.389-.464 0-1.062.165-1.691.389l-.104.03c-.839.285-1.811.615-2.666.615-.33 0-.659-.045-.943-.18-1.12-.509-1.511-1.421-1.571-2.281-.045-.614.089-1.195.254-1.806.165-.614.359-1.256.254-2.027-.165-1.364.374-2.897 1.496-3.821C5.444 2.161 7.686 2.161 8.58 2.161c.914 0 1.856.06 2.798.06 1.106 0 2.207-.06 3.299-.06zm-.751 14.47c-.195-.09-.479-.18-.824-.27l-.405-.104c-.18-.045-.359-.104-.539-.165-.719-.254-1.571-.629-2.49-.614-.883 0-1.721.359-2.474.599l-.494.165c-.3.09-.584.165-.853.165-.254 0-.509-.06-.719-.195-.479-.285-.689-.824-.689-1.481 0-.673.21-1.481.614-2.221.254-.479.599-.914 1.033-1.289.045-.03.089-.074.134-.12.479-.434 1.033-.914 1.541-1.421.21-.209.405-.434.599-.659.3-.359.599-.734.883-1.091.045-.06.09-.12.12-.179.524-.674.869-1.363.869-2.011 0-.524-.21-.989-.614-1.349-.224-.209-.509-.329-.824-.329h-.119c-.21 0-.404.045-.599.134-.12.06-.254.149-.374.254-.36.345-.659.869-.914 1.526-.045.119-.09.254-.12.389l-.045.165c-.165.734-.36 1.556-.899 2.086-.449.434-1.033.644-1.736.644-.689 0-1.289-.21-1.796-.614-.404-.344-.614-.823-.614-1.421 0-.584.195-1.151.584-1.736.509-.824 1.287-1.586 2.311-2.266l.149-.104c1.196-.793 2.594-1.691 4.019-2.311C9.56 1.068 10.757.793 11.983.793c.868 0 1.736.119 2.564.344 1.661.449 3.084 1.421 4.125 2.804.494.659.794 1.391.899 2.176.105.749-.015 1.466-.329 2.176-.195.434-.539.914-1.062 1.466-.045.045-.09.089-.134.134-.195.195-.404.404-.614.614-.509.524-1.062 1.091-1.646 1.601-.254.224-.539.434-.824.629-.449.314-.943.614-1.421.869-.195.104-.389.195-.584.285-.614.285-1.226.524-1.826.659l-.225.045c-.389.074-.779.134-1.151.134-.719 0-1.391-.165-1.961-.479-.644-.359-1.031-.914-1.106-1.601-.045-.419.075-.838.344-1.226.254-.374.644-.674 1.121-.884.12-.06.254-.104.389-.149.21-.074.434-.134.659-.165.404-.045.824-.045 1.226 0 .195.015.389.045.584.09.344.074.659.195.943.374.195.12.374.27.539.449.12.135.224.285.314.449.195.404.314.853.314 1.316 0 .524-.135 1.033-.404 1.481-.254.434-.644.779-1.121.989-.12.06-.254.104-.404.149-.254.074-.539.119-.824.119-.659 0-1.271-.21-1.766-.584-.509-.389-.794-.914-.854-1.526-.045-.404.06-.808.284-1.181.254-.419.659-.749 1.151-.959.195-.089.404-.149.629-.195.404-.074.838-.104 1.256-.074.689.045 1.346.254 1.916.614.584.374 1.031.883 1.316 1.481.165.359.254.749.254 1.151 0 .584-.12 1.151-.374 1.661-.404.808-1.091 1.421-1.961 1.751-.15.06-.315.104-.479.149-.584.149-1.211.224-1.856.224-1.211 0-2.341-.254-3.299-.749-1.091-.584-1.856-1.466-2.221-2.564-.135-.404-.195-.838-.195-1.286 0-.554.09-1.106.284-1.631.524-1.421 1.781-2.504 3.464-2.939.269-.074.554-.119.838-.149.689-.074 1.406-.074 2.101.045.404.074.808.18 1.196.329 1.032.389 1.976 1.033 2.73 1.871.27.299.509.629.719.974.375.614.614 1.301.689 2.026.045.434.015.868-.104 1.286-.254.914-.869 1.661-1.721 2.101-.404.21-.853.344-1.316.404-.584.074-1.181.074-1.781-.045-.404-.074-.794-.209-1.151-.404-.824-.434-1.466-1.121-1.856-1.991-.21-.464-.329-.974-.329-1.496 0-.3.045-.599.12-.883.285-1.016.973-1.856 1.946-2.341.195-.104.404-.18.629-.254.584-.195 1.226-.285 1.871-.285.719 0 1.436.12 2.116.359.673.239 1.271.614 1.766 1.091.509.509.883 1.121 1.091 1.796.105.314.165.644.165.989 0 .419-.09.838-.269 1.226-.404.914-1.226 1.601-2.266 1.886-.225.06-.464.104-.719.134-.584.074-1.196.089-1.796.015-.404-.045-.794-.135-1.166-.3-.914-.389-1.646-1.091-2.056-2.026-.165-.374-.254-.779-.254-1.196 0-.3.045-.599.135-.883.254-.838.794-1.541 1.541-2.011.195-.119.404-.224.629-.314.539-.224 1.121-.344 1.721-.344.614 0 1.226.12 1.796.374.584.254 1.091.644 1.466 1.151.195.269.344.569.449.883.195.584.254 1.196.18 1.796-.135 1.091-.719 2.026-1.646 2.594-.225.135-.479.254-.749.344-.584.195-1.211.285-1.856.285-.659 0-1.316-.09-1.946-.285-.614-.18-1.166-.479-1.646-.883-.509-.419-.883-.959-1.091-1.571-.105-.299-.165-.614-.165-.943 0-.419.09-.838.284-1.226.434-1.016 1.346-1.781 2.49-2.056.225-.045.464-.074.719-.089.614-.045 1.241-.015 1.856.104.404.074.794.195 1.166.359.914.404 1.646 1.136 2.026 2.116.165.404.254.838.254 1.286 0 .524-.105 1.031-.329 1.496-.509 1.061-1.466 1.856-2.654 2.191-.3.09-.614.135-.943.165-.719.074-1.451.045-2.161-.09-.404-.074-.794-.195-1.166-.344-1.091-.434-1.961-1.241-2.431-2.356-.15-.344-.239-.719-.269-1.106-.074-.824.09-1.631.509-2.341.659-1.166 1.871-1.991 3.299-2.221.3-.045.614-.074.928-.074.794 0 1.571.135 2.311.404.734.269 1.391.689 1.931 1.226.554.554.958 1.226 1.181 1.976.119.404.18.838.18 1.271 0 .614-.104 1.211-.329 1.781-.584 1.421-1.796 2.474-3.344 2.879-.344.09-.704.135-1.076.165-.838.074-1.676.015-2.49-.195-.479-.119-.943-.284-1.376-.509-1.256-.629-2.236-1.691-2.759-2.999-.165-.404-.269-.838-.329-1.286-.135-1.031.045-2.071.554-2.999.914-1.736 2.684-2.939 4.714-3.164.389-.045.779-.06 1.166-.06.883 0 1.751.15 2.579.449.823.299 1.571.764 2.191 1.364.629.614 1.106 1.364 1.391 2.191.165.464.254.959.254 1.466 0 .705-.135 1.406-.419 2.056-.689 1.661-2.101 2.879-3.884 3.324-.404.104-.823.165-1.256.195-.943.074-1.886.015-2.804-.239-.539-.149-1.061-.359-1.541-.659-1.436-.793-2.534-2.116-3.059-3.644-.165-.479-.269-.974-.329-1.481-.135-1.196.089-2.401.674-3.504 1.061-2.026 3.089-3.464 5.424-3.824.434-.074.883-.104 1.331-.104.988 0 1.961.18 2.879.539.913.359 1.736.898 2.415 1.586.689.704 1.226 1.541 1.571 2.475.195.524.314 1.076.344 1.646.074 1.061-.074 2.116-.464 3.104-.793 2.026-2.416 3.554-4.474 4.214-.479.149-.973.254-1.481.314-1.061.119-2.146.074-3.194-.195-.614-.165-1.211-.404-1.766-.719-1.616-.914-2.834-2.534-3.369-4.474-.165-.584-.269-1.196-.329-1.826-.135-1.346.119-2.714.779-3.944 1.226-2.221 3.554-3.794 6.284-4.229.494-.074.988-.119 1.496-.119 1.091 0 2.161.21 3.164.629 1.001.419 1.901 1.031 2.639 1.811.749.794 1.331 1.736 1.721 2.774.21.584.359 1.196.419 1.826.119 1.211.015 2.431-.359 3.614-.913 2.311-2.744 4.079-5.084 4.909-.539.195-1.091.344-1.661.434-1.166.18-2.356.165-3.524-.074-.689-.135-1.361-.359-1.991-.674-1.796-1.031-3.134-2.939-3.679-5.289-.18-.673-.27-1.376-.329-2.086-.119-1.496.15-2.999.854-4.329 1.391-2.415 3.999-4.049 7.014-4.509.554-.089 1.121-.135 1.691-.135z"/>
  </svg>
);

// WhatsApp Icon
const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// Telegram Icon
const TelegramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.223-.548.223l.188-2.85 5.18-4.68c.223-.198-.054-.308-.346-.11l-6.4 4.02-2.76-.918c-.6-.187-.612-.6.125-.89l10.782-4.156c.5-.176.943.112.78.89z"/>
  </svg>
);

// Pinterest Icon
const PinterestIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);

export default function ShareModal({ imageUrl, onClose }) {
  const [messageWA, setMessageWA] = useState('');
  const [caption, setCaption] = useState('');
  const [selectedPlatforms, setSelectedPlatforms] = useState({
    instagram: false,
    facebook: false,
    tiktok: false,
    snapchat: false,
    pinterest: false,
    twitter: false,
    linkedin: false
  });
  const [isSharing, setIsSharing] = useState(false);
  const [shareError, setShareError] = useState(null);

  // Escape key to close
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const togglePlatform = (platform) => {
    setSelectedPlatforms(prev => ({
      ...prev,
      [platform]: !prev[platform]
    }));
  };

  const toggleAll = () => {
    const allSelected = Object.values(selectedPlatforms).every(v => v);
    const newState = {};
    Object.keys(selectedPlatforms).forEach(key => {
      newState[key] = !allSelected;
    });
    setSelectedPlatforms(newState);
  };

  const hasAnySelected = Object.values(selectedPlatforms).some(v => v);

  const handleShare = () => {
    const text = encodeURIComponent(messageWA || 'Mein AI-Avatar von SNAPSHOT');
    const socialCaption = encodeURIComponent(caption || 'Mein AI-Avatar von SNAPSHOT');
    const url = encodeURIComponent(imageUrl);

    // Social Media Platforms
    if (selectedPlatforms.facebook) {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
    }
    if (selectedPlatforms.twitter) {
      window.open(`https://twitter.com/intent/tweet?text=${socialCaption}&url=${url}`, '_blank');
    }
    if (selectedPlatforms.pinterest) {
      window.open(`https://pinterest.com/pin/create/button/?url=${url}&description=${socialCaption}&media=${url}`, '_blank');
    }
    if (selectedPlatforms.linkedin) {
      window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank');
    }
    if (selectedPlatforms.instagram || selectedPlatforms.tiktok || selectedPlatforms.snapchat) {
      // Web Share API for these platforms
      import('../../utils/shareMedia').then(({ shareImage }) => {
        shareImage({ imageUrl, text: caption || 'Mein AI-Avatar', title: 'SNAPSHOT' }).catch(() => {
          alert('Bitte Bild herunterladen und manuell in Instagram/TikTok/Snapchat posten');
        });
      });
    }
    
    onClose();
  };
  
  const shareToWhatsApp = () => {
    const text = encodeURIComponent(messageWA || 'Mein AI-Avatar von SNAPSHOT');
    const url = encodeURIComponent(imageUrl);
    window.open(`https://wa.me/?text=${text}%20${url}`, '_blank');
  };

  const shareToTelegram = () => {
    const text = encodeURIComponent(messageWA || 'Mein AI-Avatar von SNAPSHOT');
    const url = encodeURIComponent(imageUrl);
    window.open(`https://t.me/share/url?url=${url}&text=${text}`, '_blank');
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `snapshot_${Date.now()}.jpg`;
    link.click();
  };

  // NEW: Mobile Direct Share with Web Share API
  const handleDirectShare = async () => {
    setIsSharing(true);
    setShareError(null);

    // Branding text
    const brandingText = `Mein AI-Avatar von SNAPSHOT PRO

Erstelle deinen eigenen auf www.snapshotpro.ai

SNAPSHOT PRO – Dein AI-Avatar. Deine Kreativität.`;

    console.log('🚀 Starting mobile share...');
    console.log('📸 Image URL:', imageUrl);

    // Check if Web Share API is supported
    if (!navigator.share) {
      console.error('❌ navigator.share not supported');
      setShareError('Teilen wird von deinem Browser nicht unterstützt. Bitte öffne die Seite in Safari oder Chrome.');
      setIsSharing(false);
      return;
    }

    // Check if files can be shared
    if (!navigator.canShare || !navigator.canShare({ files: [new File([], 'test.jpg', { type: 'image/jpeg' })] })) {
      console.error('❌ navigator.canShare(files) not supported');
      setShareError('Dein Browser unterstützt das Teilen von Dateien nicht. Bitte öffne die Seite in Safari oder Chrome.');
      setIsSharing(false);
      return;
    }

    try {
      console.log('📥 Fetching image...');
      
      // Try canvas method first (most reliable for cross-origin images)
      const blob = await convertImageToBlob(imageUrl);
      
      console.log('✅ Blob created:', blob.size, 'bytes, type:', blob.type);
      
      // Validate blob
      if (!blob || blob.size === 0) {
        throw new Error('EMPTY_BLOB');
      }
      
      // Create file
      const file = new File([blob], `snapshot-avatar-${Date.now()}.jpg`, { 
        type: 'image/jpeg'
      });

      console.log('✅ File created:', file.size, 'bytes');

      // Validate file size
      if (file.size === 0) {
        throw new Error('EMPTY_FILE');
      }

      console.log('📤 Attempting to share...');

      // Share with Web Share API — URL dynamisch auf aktuelle Domain
      const { absoluteUrl } = await import('../../utils/absoluteUrl');
      const shareUrl = absoluteUrl(imageUrl);
      await navigator.share({
        title: 'Mein AI-Avatar von SNAPSHOT PRO',
        text: `${brandingText}\n${shareUrl}`,
        url: shareUrl,
        files: [file]
      });

      console.log('✅ Share successful!');
      // Success - close modal
      onClose();
    } catch (error) {
      console.error('❌ Share error:', error.name, error.message);
      
      if (error.name === 'AbortError') {
        // User cancelled - just close modal
        console.log('ℹ️ User cancelled share');
        onClose();
        return;
      }
      
      // Detailed error messages
      if (error.message === 'CORS_BLOCKED' || error.message.includes('tainted')) {
        setShareError('Teilen wird durch iOS-Sicherheitsfunktion blockiert. Bitte in Safari ohne Blockierungsmodus öffnen.');
      } else if (error.message === 'EMPTY_BLOB' || error.message === 'EMPTY_FILE') {
        setShareError('Bild konnte nicht geladen werden. Bitte lade das Bild herunter und teile es manuell.');
      } else if (error.name === 'NotAllowedError') {
        setShareError('Teilen wurde blockiert. Bitte erlaube den Zugriff in deinen Browser-Einstellungen.');
        // Auto-Download als Fallback
        setTimeout(() => handleDownload(), 2000);
      } else if (error.message.includes('Image load failed')) {
        setShareError('Bild konnte nicht geladen werden. Bitte stelle sicher, dass du mit dem Internet verbunden bist.');
      } else {
        setShareError('Bild konnte nicht geteilt werden. Wir laden es stattdessen herunter...');
        // Auto-Download als Fallback
        setTimeout(() => handleDownload(), 2000);
      }
    } finally {
      setIsSharing(false);
    }
  };

  // Helper: Convert image to blob using canvas (works with cross-origin images)
  const convertImageToBlob = (url) => {
    return new Promise((resolve, reject) => {
      console.log('🎨 Converting image via canvas...');
      
      const img = new Image();
      
      // Try with CORS first
      img.crossOrigin = 'anonymous';
      
      img.onload = () => {
        try {
          console.log('✅ Image loaded:', img.naturalWidth, 'x', img.naturalHeight);
          
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          
          console.log('✅ Canvas drawn, creating blob...');
          
          canvas.toBlob((blob) => {
            if (blob && blob.size > 0) {
              console.log('✅ Blob created from canvas:', blob.size, 'bytes');
              resolve(blob);
            } else {
              console.error('❌ Canvas toBlob returned empty blob');
              reject(new Error('Canvas toBlob failed'));
            }
          }, 'image/jpeg', 0.95); // 95% quality for near-original quality
        } catch (err) {
          console.error('❌ Canvas error:', err);
          reject(err);
        }
      };
      
      img.onerror = (err) => {
        console.error('❌ Image load error:', err);
        reject(new Error('Image load failed'));
      };
      
      // Add timestamp to bust cache
      const imageUrlWithCache = url.includes('?') ? `${url}&t=${Date.now()}` : `${url}?t=${Date.now()}`;
      console.log('📥 Loading image:', imageUrlWithCache);
      img.src = imageUrlWithCache;
    });
  };

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-0 sm:p-4"
      style={{ background: 'rgba(0, 0, 0, 0.98)', backdropFilter: 'blur(20px)' }}
      onClick={onClose}
    >
      <div
        className="relative max-w-md w-full h-full sm:h-auto bg-black border-0 sm:border-2 border-white/20 rounded-none sm:rounded-2xl p-6 glow-green-soft max-h-full sm:max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ paddingTop: 'max(1.5rem, env(safe-area-inset-top))' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-white">Teilen</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-xl border-2 border-white/30 text-white hover:bg-white/10 transition-all"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Preview Image */}
        <div 
          className="mb-4 rounded-xl overflow-hidden border-2 border-white/10"
          onTouchStart={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
          onTouchEnd={(e) => e.stopPropagation()}
        >
          <img 
            src={imageUrl} 
            alt="Share Preview" 
            className="w-full h-auto select-none pointer-events-none"
            draggable={false}
          />
        </div>

        {/* Mobile-Only: Direct Share Button */}
        <div className="block">
          {/* Intro Text */}
          <p className="text-white/70 text-sm mb-4 leading-relaxed">
            Teile dein Bild direkt mit deinen Freunden über WhatsApp, Telegram, Instagram, Facebook und mehr!
          </p>

          {/* Error Message */}
          {shareError && (
            <div className="mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
              <p className="text-red-400 text-xs leading-relaxed">{shareError}</p>
            </div>
          )}

          {/* Main Share Button */}
          <button
            onClick={handleDirectShare}
            disabled={isSharing}
            className={`w-full py-4 px-6 rounded-xl font-bold transition-all flex items-center justify-center gap-3 ${
              isSharing
                ? 'bg-white/10 text-white/40 cursor-not-allowed'
                : 'bg-gradient-to-br from-emerald-400 via-green-500 to-emerald-600 text-black hover:shadow-2xl hover:shadow-emerald-500/60 hover:scale-[1.02] shadow-xl shadow-emerald-500/50'
            }`}
          >
            {isSharing ? (
              <>
                <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                <span>Wird geladen...</span>
              </>
            ) : (
              <>
                <span className="text-xl">📸</span>
                <span>Bild direkt teilen</span>
              </>
            )}
          </button>

          {/* Helper Text */}
          <p className="text-white/40 text-xs mt-3 text-center leading-relaxed">
            Volle Bildqualität • Deine Kreativität • SNAPSHOT PRO
          </p>
          
          {/* iOS WhatsApp Tip */}
          <div className="mt-4 p-3 bg-emerald-500/10 border border-emerald-500/30 rounded-lg">
            <p className="text-white/60 text-xs leading-relaxed text-center">
              💡 <span className="font-semibold text-white/80">Tipp für iOS:</span> Falls WhatsApp/Telegram nicht direkt öffnet, starte die App kurz im Hintergrund und versuche es erneut.
            </p>
          </div>
        </div>

        {/* HIDDEN: Original Social Media Section (for future use) */}
        <div className="hidden">
          {/* Intro Text */}
          <p className="text-white/70 text-sm mb-6 leading-relaxed">
            Wähle eine oder mehrere Plattformen und teile dein Bild direkt mit der Welt!
          </p>

          {/* WhatsApp & Telegram Section */}
          <div className="mb-6 p-4 bg-white/5 border border-white/10 rounded-xl">
            <h3 className="text-sm font-bold text-white mb-3">Messenger</h3>
            
            {/* WhatsApp/Telegram Textfeld */}
            <div className="mb-3">
              <textarea
                value={messageWA}
                onChange={(e) => setMessageWA(e.target.value)}
                maxLength={500}
                placeholder="Nachricht für WhatsApp/Telegram (optional)"
                className="w-full px-3 py-2 bg-black border border-white/20 rounded-lg text-white text-sm placeholder:text-white/40 resize-none focus:outline-none focus:border-cyan-400 transition-all"
                rows={2}
              />
              <div className="text-xs text-white/40 mt-1 text-right">{messageWA.length}/500</div>
            </div>

            {/* WhatsApp + Telegram Buttons */}
            <div className="grid grid-cols-2 gap-2">
              <button
                onClick={shareToWhatsApp}
                className="flex items-center justify-center gap-2 py-2 px-3 bg-white/5 border border-white/20 rounded-lg hover:bg-white/10 hover:border-cyan-400/50 transition-all"
              >
                <WhatsAppIcon className="w-4 h-4 text-white" />
                <span className="text-white text-xs font-semibold">WhatsApp</span>
              </button>
              <button
                onClick={shareToTelegram}
                className="flex items-center justify-center gap-2 py-2 px-3 bg-white/5 border border-white/20 rounded-lg hover:bg-white/10 hover:border-cyan-400/50 transition-all"
              >
                <TelegramIcon className="w-4 h-4 text-white" />
                <span className="text-white text-xs font-semibold">Telegram</span>
              </button>
            </div>
          </div>

          {/* Separator */}
          <div className="border-t border-white/10 my-6"></div>

          {/* Social Media Section */}
          <div className="mb-6">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-bold text-white">Social Media</h3>
              <button
                onClick={toggleAll}
                className="text-xs text-cyan-400 hover:text-cyan-300 transition-colors font-semibold"
              >
                {Object.values(selectedPlatforms).every(v => v) ? '❌ Alle abwählen' : '✅ Alle auswählen'}
              </button>
            </div>

            {/* Social Media Caption */}
            <div className="mb-3">
              <textarea
                value={caption}
                onChange={(e) => setCaption(e.target.value)}
                maxLength={2000}
                placeholder="Bild-Caption für Social Media (optional)"
                className="w-full px-3 py-2 bg-black border border-white/20 rounded-lg text-white text-sm placeholder:text-white/40 resize-none focus:outline-none focus:border-cyan-400 transition-all"
                rows={2}
              />
              <div className="text-xs text-white/40 mt-1 text-right">{caption.length}/2000</div>
            </div>

            {/* Platform Checkboxes */}
            <div className="space-y-2">
              <PlatformCheckbox 
                platform="instagram" 
                label="Instagram" 
                icon={<Instagram className="w-4 h-4" />}
                selected={selectedPlatforms.instagram}
                onToggle={togglePlatform}
              />
              <PlatformCheckbox 
                platform="tiktok" 
                label="TikTok" 
                icon={<TikTokIcon className="w-4 h-4" />}
                selected={selectedPlatforms.tiktok}
                onToggle={togglePlatform}
              />
              <PlatformCheckbox 
                platform="snapchat" 
                label="Snapchat" 
                icon={<SnapchatIcon className="w-4 h-4" />}
                selected={selectedPlatforms.snapchat}
                onToggle={togglePlatform}
              />
              <PlatformCheckbox 
                platform="facebook" 
                label="Facebook" 
                icon={<Facebook className="w-4 h-4" />}
                selected={selectedPlatforms.facebook}
                onToggle={togglePlatform}
              />
              <PlatformCheckbox 
                platform="twitter" 
                label="X (Twitter)" 
                icon={<Twitter className="w-4 h-4" />}
                selected={selectedPlatforms.twitter}
                onToggle={togglePlatform}
              />
              <PlatformCheckbox 
                platform="pinterest" 
                label="Pinterest" 
                icon={<PinterestIcon className="w-4 h-4" />}
                selected={selectedPlatforms.pinterest}
                onToggle={togglePlatform}
              />
              <PlatformCheckbox 
                platform="linkedin" 
                label="LinkedIn" 
                icon={<Linkedin className="w-4 h-4" />}
                selected={selectedPlatforms.linkedin}
                onToggle={togglePlatform}
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleDownload}
              className="flex-1 py-3 px-4 border-2 border-white/30 text-white rounded-xl hover:bg-white/5 transition-all font-semibold flex items-center justify-center gap-2 text-sm"
            >
              <Download className="w-4 h-4" />
              Download
            </button>
            <button
              onClick={handleShare}
              disabled={!hasAnySelected}
              className={`flex-1 py-3 px-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2 text-sm ${
                hasAnySelected
                  ? 'bg-gradient-to-br from-cyan-400 via-cyan-500 to-teal-500 text-black hover:shadow-2xl hover:shadow-cyan-500/60 hover:scale-[1.02] shadow-xl shadow-cyan-500/50'
                  : 'bg-white/10 text-white/40 cursor-not-allowed'
              }`}
            >
              🚀 Jetzt teilen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Platform Checkbox Component
const PlatformCheckbox = ({ platform, label, icon, selected, onToggle }) => (
  <button
    onClick={() => onToggle(platform)}
    className={`w-full flex items-center gap-3 p-2.5 rounded-lg transition-all ${
      selected
        ? 'bg-cyan-500/20 border border-cyan-500/50'
        : 'bg-white/5 border border-white/20 hover:bg-white/10'
    }`}
  >
    <div className={`w-4 h-4 rounded border-2 flex items-center justify-center transition-all flex-shrink-0 ${
      selected ? 'bg-cyan-500 border-cyan-500' : 'border-white/30'
    }`}>
      {selected && (
        <svg className="w-2.5 h-2.5 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      )}
    </div>
    <div className={`transition-colors ${selected ? 'text-cyan-400' : 'text-white/60'}`}>
      {icon}
    </div>
    <span className={`font-medium text-sm transition-colors ${selected ? 'text-white' : 'text-white/80'}`}>
      {label}
    </span>
  </button>
);
